import React from "react";
import useLang from "Shared/hooks/useLanguage";
import PathologyReportSelect from "../PathologyReportSelect";
import {
  SYNOPTIC_NO_NEEDED_LABEL,
  synopticTumorSiteOptions,
  type SelectOption,
} from "../pathologyReportData";

type Props = {
  tumorSite: SelectOption | null;
  onTumorSiteChange: (value: SelectOption | null) => void;
};

const SynopticTab = ({ tumorSite, onTumorSiteChange }: Props) => {
  const { t } = useLang();

  return (
    <div>
      <label className="form-label fw-semibold text-gray-700">
        {t("Tumor site (loads CAP protocol)")}{" "}
        <span className="text-danger">*</span>
      </label>
      <PathologyReportSelect
        value={tumorSite}
        onChange={onTumorSiteChange}
        options={synopticTumorSiteOptions}
        placeholder={SYNOPTIC_NO_NEEDED_LABEL}
      />
      <div
        className="rounded-3 px-4 py-4 mt-4"
        style={{ backgroundColor: "#fff8e1", border: "1px solid #ffe082" }}
      >
        <div className="fw-semibold text-gray-800 mb-1">
          {t("Select a tumor site above to load the CAP synoptic checklist")}
        </div>
        <div className="text-gray-600 fs-7">
          {t(
            "Structured fields for procedure, tumor type, grade, margins, staging, and more"
          )}
        </div>
      </div>
    </div>
  );
};

export default SynopticTab;
